import * as MyselfActionTypes from 'actiontypes/myself';
// import * as ExchangeActionTypes from 'actiontypes/exchange';

import fetchOutfitSuccess from './fetchOutfitSuccess';
import { IOutfitState } from 'types/outfit';

const INITIAL_STATE: IOutfitState = {
  isChanging: false,
  isExpanded: false,
  Hat: undefined,
  Clothing: undefined,
  Gloves: undefined,
  Weapon: undefined,
  Boots: undefined,
  Companion: undefined,
  Destiny: undefined,
  Affiliation: undefined,
  Transporation: undefined,
  HomeComfort: undefined,
  Ship: undefined,
  Spouse: undefined,
  Club: undefined,
};

export default function reducer(state = INITIAL_STATE, action: any) {
  const { type, payload } = action;
  switch (type) {
    case MyselfActionTypes.CHANGE_OUTFIT_REQUESTED:
    case MyselfActionTypes.EQUIP_QUALITY_REQUESTED:
      return { ...state, isChanging: true };

    case MyselfActionTypes.EQUIP_QUALITY_SUCCESS:
      return fetchOutfitSuccess(state, payload);

    case MyselfActionTypes.CHANGE_OUTFIT_SUCCESS:
      return fetchOutfitSuccess(state, payload);

    case MyselfActionTypes.FETCH_OUTFIT_SUCCESS:
      return fetchOutfitSuccess(state, payload);

    case MyselfActionTypes.TOGGLE_EXPANDED_POSSESSIONS:
      return { ...state, isExpanded: !state.isExpanded };

    default:
      return state;
  }
}